import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'component-halves-container',
  templateUrl: './halfs-container.component.html',
  styleUrls: ['./halfs-container.component.css','../../../styles.scss'],
})
export class HalfsContainerComponent implements OnInit {
  @Input() imgUrl:string="";
  @Input() infoHeaderTemplate: string|undefined;
  @Input() paragraphTemplate: string|undefined;
  @Input() textOnButton:string="";
  @Input() imgWidth:string="500";
  @Input() bgColor:string="";
  @Input() hrefBtn:string = "";
  @Input() btnLink: string = "";
  @Input() fragment: string = "";
  @Input() btnBg: string | undefined;
  @Input() imageToRight: boolean = false;
  @Input() topParagraph: boolean = false;


  constructor() { }

  ngOnInit(): void {
  }

}
